export default {
  variantColors: [],
  variantColor: {},
};
